/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from "react-redux";
import ListView from "../../../Utils/ListView";
import Highlighter from "react-highlight-words";
import { Popconfirm, Input, Tooltip,Button } from "antd";
import { encode as base64_encode } from "base-64";
import { constant } from "../../../Utils/constants";
import React, { useState, useEffect, useRef } from "react";
import translation from "../../../../../commons/translation";
import { API_MASTERITEMS } from "../../../../../commons/api";

import {
  getMasterList,
  deleteMaster,
  getUsersList,
} from "../../../Utils/FormCalls";
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const urlList = {
  list: `${API_MASTERITEMS.LIST}`,
  delete: `${API_MASTERITEMS.DELETE}`,
};

const ItemList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const { translationCache, navigate } = props;

  useEffect(() => {
    const fetchData = async () => {
      const data = await getMasterList(urlList.list);
      setDataSource(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchUserList = async () => {
      const users = await getUsersList();
      setUserList(users);
    };
    fetchUserList();
  }, []);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const editAssetMaster = (record) => {
    const redirectURL = `/rubus/AMM/ItemDetails/${base64_encode(record.Id)}`;
    navigate({ pathname: redirectURL });
  };

  const deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    const data = await getMasterList(urlList.list);
    setDataSource(data);
  };

  const columns = [
    {
      title: translation(translationCache, constant.item),
      dataIndex: 'Item',
      key: 'Item',
      filter: true,
      ...getColumnSearchProps('Item')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.storeLocation),
      dataIndex: 'StoreLocation',
      key: 'StoreLocation',
      filter: true
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button style={{ marginRight: '10px' }} onClick={() => editAssetMaster(record)}>
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, constant.deleteItemMaster)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Button >
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  const config = {
    title: translation(translationCache, constant.ITEM_MASTER),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Item'],
    firstTitle: 'Item',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/ItemDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        userList={userList}
        config={config}
        delete={deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(ItemList);